import { render, staticRenderFns } from "./CommonHome.vue?vue&type=template&id=23402fab&scoped=true&"
import script from "./CommonHome.vue?vue&type=script&lang=js&"
export * from "./CommonHome.vue?vue&type=script&lang=js&"
import style0 from "./CommonHome.vue?vue&type=style&index=0&id=23402fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23402fab",
  null
  
)

export default component.exports